import {Component, OnInit} from '@angular/core';
import {
  QuarantinePlacementFormComponent
} from "@app/quarantine/quarantine-placement-form/quarantine-placement-form.component";
import {QuarantinePlacementFormInterface} from "@app/quarantine/intrfaces/quarantine.interface";
import {ActivatedRoute} from "@angular/router";
import {DataService} from "@app/shared/data.service";

@Component({
  selector: 'app-create-plecement',
  templateUrl: './create-quarantine-placement.component.html',
  styleUrls: ['./create-quarantine-placement.component.scss'],
  standalone: true,
  imports: [
    QuarantinePlacementFormComponent,
  ]
})
export class CreateQuarantinePlacementComponent implements OnInit{
  constructor(
      private activatedRoute: ActivatedRoute,
      private dataService: DataService
  ) {
  }
  
  ngOnInit() {
    let breadcrumbs = [...this.activatedRoute.snapshot.data['breadcrumbs']]
    breadcrumbs.push({title: 'Створити розміщення у карантин', link: ''});
    this.dataService.breadcrumbsArray.next(breadcrumbs)
  }
  
  config: QuarantinePlacementFormInterface = {
    documentType: 'QUARANTINE_PLACEMENT',
    stage: "CREATE",
  }
}
